import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ValidationService } from "../public-api";

@Component({
  selector: "Pin-Validation",
  templateUrl: "./validation.component.html",
  styleUrls: ["./validation.component.css"]
})
export class ValidationComponent implements OnInit {
  @Input() private length: any;
  @Input() theme: any;
  @Input() type: any;
  @Input() custom: any;

  @Output() codeNumber: EventEmitter<any> = new EventEmitter();

  allInputs = document.getElementsByTagName("input");

  code: string = "";
  value: any;
  disabled = false;
  count = 0;

  constructor(public pinValid: ValidationService) {}

  ngOnInit() {
    this.value = new Array();
    this.setCodeLength(this.length);

    if (this.pinValid.subsVar == undefined) {
      this.pinValid.subsVar = this.pinValid.clearInputs.subscribe(
        (name: string) => {
          this.focusFunction();
        }
      );
    }
  }

  setCodeLength(codeLength) {
    for (let i = 0; i < codeLength; i++) {
      this.value.push(i);
    }
  }

  keytab(event) {
    console.log(this.allInputs);

    console.log(event);
    const element = event.srcElement.nextElementSibling;
    this.code = this.code + event.key;

    if (element == null) {
      this.disabled = true;
      this.processFinished();
      return;
    } else {
      element.focus();
    }
  }

  // When user delete a number
  backspaceKey(event) {
    const that = this;
    event.srcElement.value = "";
    const element = event.srcElement.previousElementSibling;
    this.count = this.count - 1;
    if (element == null) {
      return;
    } else {
      this.code = this.code.substring(0, that.code.length - 1);
      element.value = "";
      element.focus();
    }
  }

  focusFunction() {
    for (let i = 0; i < this.allInputs.length; i++) {
      this.allInputs[i].value = "";
      this.code = "";
    }
    this.allInputs[0].focus();
  }

  processFinished() {
    console.log(this.code);
    this.codeNumber.emit(this.code);
  }
}
